/** Shared dimensions: VapiCamera and VapiChair use the same size */
export const CHAIR_CAMERA_DIMS = [480, 360];
